module.exports = __webpack_public_path__ + "img/question-shms-active.b47fd8b4.png";